import { toast } from "react-toastify";
import { RepositoryFactory } from "../../Repository/RepositoryFactory";
import { CITIES, STATES, COUNTRIES } from "../types";
let statesCities = RepositoryFactory.get("statesCities");

export const getStatesCities = (stateName, onSuccess) => async (dispatch) => {
    try {
        const { data } = stateName
            ? await statesCities.fetchCities(stateName)
            : await statesCities.fetchStates();

        if (data.success) {
            dispatch({
                type: stateName ? CITIES : STATES,
                payload: data?.data,
            });
        }
    } catch (error) {
        toast.error(
            error?.response?.data?.message ||
                error?.data?.message ||
                error.message ||
                "Something Went Wrong"
        );
        console.error("error: ", error);
    }
};

export const getStates = (country, onSuccess) => async (dispatch) => {
    try {
        const { data } = await statesCities.fetchStates(country);

        if (data.success) {
            dispatch({ type: STATES, payload: data?.data });
        }
    } catch (error) {
        toast.error(
            error?.response?.data?.message ||
                error?.data?.message ||
                error.message ||
                "Something Went Wrong"
        );
        console.error("error: ", error);
    }
};

export const getCountries = (onSuccess) => async (dispatch) => {
    try {
        const { data } = await statesCities.fetchCountries();

        if (data.success) {
            dispatch({ type: COUNTRIES, payload: data?.data });
        }
    } catch (error) {
        toast.error(
            error?.response?.data?.message ||
                error?.data?.message ||
                error.message ||
                "Something Went Wrong"
        );
        console.error("error: ", error);
    }
};
